import PropTypes from 'prop-types';
import GoFetch from '~/js/modules/fetchling';

// const loginCreateFetch = new GoFetch();
const itemOnAddFetch = new GoFetch();

export default class SignUp extends React.Component {
  static propTypes = {
    countries: PropTypes.array,
    handlerIsSignUp: PropTypes.func,
    isSuccessAddedHandler: PropTypes.func,
    handlerAfterLogIn: PropTypes.func,
    modalUpdateHandler: PropTypes.func,
    getModifiedWishList: PropTypes.func,
    itemDetails: PropTypes.object,
    isAddItem: PropTypes.bool
  };
  static defaultProps = {
    countries: {},
    itemDetails: {},
    getModifiedWishList: () => null,
    isSuccessAddedHandler: () => null,
    handlerIsSignUp: () => null,
    modalUpdateHandler: () => null,
    isAddItem: false
  };
  constructor() {
    super();
    this.state = {
      fetchErrorBody: {},
      showFetchError: false,
      emailValue: '',
      maskedEmailValue: ''
    };
  }

  _validateFields = (email, lastName, country, wishListName) => {
    const emailFilter = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/igm;
    let msg = '';

    if (wishListName === '') { msg += '<li>Enter the Wishlist\'s name</li>'; }
    if (email === '') { msg += '<li>Enter your Email.</li>'; }
    if (lastName === '') { msg += '<li>Enter your Last Name</li>'; }
    if (country === '') { msg += '<li>Enter your Country of Residence.</li>'; }
    if ((email !== '') && emailFilter.test(email) === false) { msg += '<li>A valid E-mail Address</li>';}

    document.getElementById('error-msg').innerHTML = msg;

    return msg;
  };
  _fetchErrorHandler = (response) => {
    const errorBody = $.extend(true, {}, this.state.fetchErrorBody);

    errorBody.name = response.message;
    this.setState({ showFetchError: true, fetchErrorBody: errorBody });
  };
  _loginCreate = (e) => {
    e.preventDefault();
    const wishListName = $('input[name=wishListName]').val().trim();
    const email = this.state.emailValue.trim();
    const lastName = $('#lastName').val().trim();
    const countrySelected = $('select[name="country"]').find(':selected').attr('value');
    const msg = this._validateFields(email, lastName, countrySelected, wishListName );
    const requestBody = {
      email: `${email}`,
      lastName: `${lastName}`,
      country: `${countrySelected}`,
      csrfToken: window.beaches_app.page.csrfToken
    };

    _globalUtils.loaderHelper();
    if (msg === '') {
      $.ajax({
        url: '/weddings/sign-up/',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(requestBody)
      })
        .done((result) => {
          if (result.status === 'fail') {
            this._fetchErrorHandler(result);
            _globalUtils.loaderHelper(false);
          } else {
            this._loginUser(email, lastName, countrySelected);
            this._createWishList(result.data.newUserId, wishListName);
            // $.magnificPopup.close();
          }
        })
        .fail((textStatus, errorThrown) => console.error(errorThrown));

    } else {
      _globalUtils.loaderHelper(false);
      console.log('login create failed');
      // alert(`Please enter the following: ${msg}`);
    }
  };
  _loginUser = (email, lastName, country) => {
    const requestBody = {
      email: `${email}`,
      lastName: `${lastName}`,
      country: `${country}`,
      csrfToken: window.beaches_app.page.csrfToken
    };

    $.ajax({
      url: '/wsLogin/',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(requestBody)
    })
      .done(() => {
        this.props.handlerAfterLogIn();
      })
      .fail((textStatus, errorThrown) => console.warn(errorThrown));
  };
  _createWishList = (userId, wishListName) => {
    const requestBody = {
      wishListName: `${wishListName}`,
      userId: `${userId}`,
      regionId: 10,
      csrfToken: window.beaches_app.page.csrfToken
    };

    $.ajax({
      url: '/wishlist/save/',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(requestBody)
    })
      .done((result) => {
        $('body').removeClass('html-no-scroll');
        this.props.isAddItem && this._addToWishList(userId, wishListName, result.data.saveWishListResult[0].id, result.data.saveWishListResult[0].regionId);
      })
      .fail((textStatus, errorThrown) => console.warn(errorThrown));
  };
  _addToWishList = (userId, wishListName, wishListId, wishListRegionId)  => {
    const { itemDetails } = this.props;
    const requestBody = {
      csrfToken: window.beaches_app.page.csrfToken,
      wishListId: `${wishListId}`,
      userId: `${userId}`,
      regionId: `${wishListRegionId}`,
      items: [
        {
          price: `${itemDetails.price}`,
          quantity: `${itemDetails.quantity}`,
          attributeId: `${itemDetails.currentAttributeId}`
        }
      ]
    };

    $.ajax({
      url: '/wishlist/save/',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(requestBody)
    })
      .done(() => {
        this.props.isSuccessAddedHandler(true);
        this.props.getModifiedWishList(wishListName);
        this._fetchItemDetails(itemDetails.currentAttributeId, userId);
        _globalUtils.loaderHelper(false);
        // this.props.updateWishListHandler(result.data.saveWishListResult);
      })
      .fail((textStatus, errorThrown) => console.warn(errorThrown));

  };
  _fetchItemDetails = (attributeId, userId) => {
    const requestBody = { attributeId, userId };
    const itemContent = document.querySelector('.item-details');

    $('.sk-loader-item').show();
    itemContent.classList.add('hide');
    itemOnAddFetch.post('/weddingStyler/item/details/', null, requestBody)
      .then(response => {
        this._setDefaultDetails(response.data.itemDetails, attributeId);
      })
      .then(() => itemContent.classList.remove('hide'))
      .then(() => $('.sk-loader-item').hide())
      .catch((err) => console.warn(err));
  };
  _setDefaultDetails = (fetchDetails, attributeId) => {
    fetchDetails.currentAttributeId = attributeId;
    // fetchDetails.price = this.props.itemDetails.price ? this.props.itemDetails.price : 0;
    fetchDetails.total = this.props.itemDetails.total;
    fetchDetails.destinationPrice = this.props.itemDetails.destinationPrice;
    fetchDetails.currentRegionId = this.props.itemDetails.currentRegionId;
    fetchDetails.hiddenPriceFlag = this.props.itemDetails.priceList[0].hiddenPrice;
    fetchDetails.quantity = this.props.itemDetails.quantity;
    fetchDetails.quantityAdded = this.props.itemDetails.quantity;

    this.props.modalUpdateHandler(fetchDetails);
  };
  _renderCountriesList = (countries) => countries.map(country => <option key={country.id} value={country.code}>{country.name}</option>);

  _getCurrentCountryCode = (e) => {
    this.setState({country: e.target.value});
  };
  _maskEmail = (e) => {
    const value = e.target.value;
    const regex = /(.)(.*)(@.*)/gi;
    const newValue = value.replace(regex, '$1***$3');

    this.setState({maskedEmailValue: newValue});
  };
  _handleEmailChange = (e) => {
    this.setState({emailValue: e.target.value, maskedEmailValue: e.target.value});

  };
  _clearMaskedEmailValue = () => {
    this.setState({emailValue: '', maskedEmailValue: ''});
  };
  _clearInput = (e) => {
    const clicked = e.target.id;
    const inputToClear = clicked === 'clear-email' ? 'email' : 'lastName';

    document.getElementById(inputToClear).value = '';
  };
  _changeComponentAndScroll = () => {
    this.props.handlerIsSignUp(false);
    /*$('html, body').animate({
      scrollTop: $('#dashboard-modal').offset().top
    }, 2000);*/
  };

  render() {
    const { showFetchError, fetchErrorBody } = this.state;
    const { countries } = this.props;
    const countryList = this._renderCountriesList(countries);

    return(
      <div className="row center-xs sign-up-wrapper container-fluid">
        <h2 className="xs-12 create-wl uppercase">Create a wishlist</h2>
        <form className="xs-12 signUp-form">
          <div className="row center-xs">
            <div className="xs-12 lg-8 error-wrapper">
              <ul id="error-msg"/>
            </div>
            <div className="xs-12 create-input">
              <div className="control-wrapper">
                <input type="text" name="wishListName" id="wishListName" placeholder="Name your Wishlist" maxLength="30" required />
              </div>
            </div>
            <span className={ showFetchError ? 'show xs-12 lg-8 errorOnCreate txt-center' : 'hide' }>{ fetchErrorBody.name }</span>
            <div className="xs-12 login-wrapper">
              <h3 className="edits-intro">All Wishlists edits will be saved instantly. Please provide the following:</h3>
              <div className="control-wrapper custom-ddl">
                <select name="country" id="country" required onChange={this._getCurrentCountryCode}>
                  <option value="">Country of Residence</option>
                  <option value="US">UNITED STATES</option>
                  <option value="CA">CANADA</option>
                  <option value="GB">UNITED KINGDOM</option>
                  {countryList}
                </select>
              </div>
              <div className="control-wrapper last-control">
                <input type="email" value={this.state.maskedEmailValue} onChange={this._handleEmailChange} onBlur={this._maskEmail} onFocus={this._clearMaskedEmailValue} name="email" id="email" placeholder="Your Email" required />
                <span className="clear-arrow" id="clear-email" onClick={this._clearInput}/>
              </div>
              <div className="control-wrapper">
                <input type="text" id="lastName" name="lastName" placeholder="Your Last Name" required />
                <span className="clear-arrow" id="clear-lastName" onClick={this._clearInput}/>
              </div>
            </div>

            <div className="xs-12 container-fluid terms">
              <div className="row">
                <strong className="xs-12 special-offers">want to receive sandals specials offers?</strong>
                <div className="control-wrapper offer-control xs-1">
                  <input className="" type="checkbox" id="specialOffer" name="specialOffer"/>
                </div>
                <span className="xs-10 lg-10 special-accept">
                  { this.state.country === 'CA'
                    ? 'I want to receive promotional emails about Sandals Resorts from Unique Travel Corp., the Worldwide Representative of Sandals Resorts, c/o P.O. Box SS-19020, Nassau, Bahamas. You can contact us at info@sandals.com. You may unsubscribe at any time.'
                    : 'Yes, I want to receive promotional emails, special savings and event notifications about Sandals Resorts.'
                  }
                </span>
              </div>
            </div>

            <div className="xs-12 lg-8">
              <button onClick={ this._loginCreate } className="form-submit-button">Create Wishlist</button>
            </div>
          </div>
        </form>
        <div className="xs-12">
          <a className="already-wishlist" onClick={this._changeComponentAndScroll}><i className="icon-arrow-right"/>
              already have a wishlist(s)
          </a>
        </div>
      </div>
    );
  }
}
